import React from 'react'

export const ColorDisplay = ({ color }) => {
  // Función para verificar si el color es válido
  const isValidColor = (strColor) => {
    const s = new Option().style
    s.color = strColor
    return s.color !== ''
  }

  // Verificar si el color es válido
  const validColor = isValidColor(color)

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div
        style={{
          width: '20px',
          height: '20px',
          backgroundColor: validColor ? color : '',
          border: '1px solid',
          borderColor: validColor ? color : 'black',
        }}
      />
      <div style={{ marginLeft: '10px' }}>{validColor ? color : 'Color inválido'}</div>
    </div>
  )
}
